import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = ["viewBox", "width", "height"]
const _hoisted_3 = ["d"]
const _hoisted_4 = {
  key: 1,
  class: "qr-placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "qr-wrapper",
    style: _normalizeStyle({ width: _ctx.size + 'px', height: _ctx.size + 'px' }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('copy'))),
    title: _ctx.title
  }, [
    (_ctx.dataUrl)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          viewBox: `0 0 ${_ctx.cellCount} ${_ctx.cellCount}`,
          width: _ctx.size,
          height: _ctx.size,
          xmlns: "http://www.w3.org/2000/svg",
          class: "qr-svg",
          preserveAspectRatio: "xMidYMid meet"
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("rect", {
            width: "100%",
            height: "100%",
            fill: "#ffffff"
          }, null, -1)),
          _createElementVNode("path", {
            d: _ctx.pathD,
            fill: "#000000"
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, "…"))
  ], 12, _hoisted_1))
}